// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"207":"a8d87010","563":"308ac40f","806":"a44c5fa4"}[chunkId] + ".chunk.css";
};